import { render, staticRenderFns } from "./PropItem.vue?vue&type=template&id=769e23be&scoped=true&"
import script from "./PropItem.vue?vue&type=script&lang=js&"
export * from "./PropItem.vue?vue&type=script&lang=js&"
import style0 from "./PropItem.vue?vue&type=style&index=0&id=769e23be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e23be",
  null
  
)

export default component.exports